import { render } from "./Contratos.vue?vue&type=template&id=4b895bd0&scoped=true"
import script from "./Contratos.vue?vue&type=script&lang=js"
export * from "./Contratos.vue?vue&type=script&lang=js"

import "./Contratos.vue?vue&type=style&index=0&id=4b895bd0&scoped=true&lang=css"

import exportComponent from "/mnt/gasoil_files/gasoil/docker/gasoil/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b895bd0"]])

export default __exports__